import { AR } from './dictionaries/ar';
import type { Dictionary } from './dictionaries/dictionaryTypes';
import { EN } from './dictionaries/en';
import { ES } from './dictionaries/es';
import { FR } from './dictionaries/fr';
import { RU } from './dictionaries/ru';
import { ZH_CN } from './dictionaries/zh-CN';
import { ZH_HK } from './dictionaries/zh-HK';
import type { SupportedLocale } from './logic';

export type { Dictionary };

export const dictionaries: Record<SupportedLocale, Dictionary> = {
    ru: RU,
    en: EN,
    es: ES,
    fr: FR,
    ar: AR,
    'zh-CN': ZH_CN,
    'zh-HK': ZH_HK,
};

export const DEFAULT_DICTIONARY = RU;

export const getDictionary = (locale: SupportedLocale): Dictionary => dictionaries[locale];

export type AppDictionary = Dictionary;
